import {
  AgentEndpoints,
  type CommonResponse,
  type RequestDeps,
  RequestMethods,
  useRequest,
} from '@shared/index';

import type { UpdateProfileDraftRequestParams } from './update-profile-draft.types';

export const useUpdateProfileDraft = (
  request: UpdateProfileDraftRequestParams,
  deps?: RequestDeps
) => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    UpdateProfileDraftRequestParams,
    CommonResponse,
    CommonResponse
  >({
    params: {
      key: 'updateProfileDraft',
      method: RequestMethods.POST,
      url: `${AgentEndpoints.AGENTS}/contracts/personal-data-draft`,
      request,
      fetchManual: true,
      deps,
    },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
